__turbopack_context__.v({
  "className": "NBWgJW_className",
  "variable": "NBWgJW_variable",
});
